import script from "./ChangeLevel.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeLevel.vue?vue&type=script&setup=true&lang=js"

import "./ChangeLevel.vue?vue&type=style&index=0&id=79029cde&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79029cde"]])

export default __exports__